import _get from 'lodash/get'
import request from '../../request'
import { createAuthorization } from '../../auth'

/**
 * Perform a request to identify if an email is available or not.
 *
 * @param {string} param0.server
 * @param {object} param0.auth
 * @param {object} param0.body
 * @returns {object}
 */
export async function getEmailAvailability ({ server, auth, body }) {
  const res = await request
    .post(`${server}/v1/checkout/account-check`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .send(body)

  return _get(res, 'body', { success: false })
}
